import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import 'amfe-flexible'
import './assets/style/common.scss'
import './assets/style/emsrs.scss'
import api from './api/index'
import global from './util/global'
import wechatAuth from './util/wechatAuth'
import VueAMap from 'vue-amap';



import TopHead from './components/TopHead.vue';//底部菜单栏
import FootTab from './components/FootTab.vue';//底部菜单栏
import {  Image as VanImage ,RadioGroup, Radio, Dialog, Collapse, CollapseItem, ActionSheet, Icon, CountDown,  Checkbox, CheckboxGroup, Calendar, Tab, Tabs, PullRefresh, Toast, List, Overlay, Picker, Popup, Swipe, SwipeItem } from 'vant';

const app = createApp(App).use(router);


app.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: 'f130b8f9217a257d1a825e072af59bbb',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4',
//   uiVersion: '1.0.11'
// });

app.use(wechatAuth);  // 领创appid  测试

app.use(Swipe);
app.use(SwipeItem);
app.use(ActionSheet);
app.use(Icon);
app.use(CountDown);
app.use(Radio);
app.use(RadioGroup);
app.use(Tab);
app.use(Tabs);
app.use(PullRefresh);
app.use(List);
app.use(Overlay);
app.use(Picker);
app.use(Popup);
app.use(Calendar);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Collapse);
app.use(CollapseItem);
app.use(VanImage);

app.config.globalProperties.$global = global; // 全局定义global
app.config.globalProperties.$renderTime = renderTime; // 全局定义修改ios时间格式
app.config.globalProperties.$api = api; // 全局定义api
app.config.globalProperties.$toast = Toast; // 全局定义Toast
app.config.globalProperties.$dialog = Dialog; // 全局定义Toast
app.component('TopHead',TopHead);
app.component('FootTab',FootTab);

app.mount('#app')


function renderTime(t) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf("Linux") > -1;   //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1 || u.indexOf('iPad') > -1 || (/Safari/.test(u) && !/Chrome/.test(u)); //ios终端
  if(isiOS){
    return t.replace(/\-/g,'/')
  }else{
    return t;
  }
}
